var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sg-button',{attrs:{"type":"submit","color":"orange","disabled":_vm.useDisabled,"full-width":_vm.fullWidth}},[_vm._v("\n  "+_vm._s(_vm.useLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }